import INoteTag from "./INoteTag";
import { INoteTagContentBuilder } from "./INoteTagContentBuilder";

/**
 * An implementation of {@link INoteTagContentBuilder} which composes the given tags in the same order presented, and
 * splits them with the configured separator.
 */
class SeriesSeparatorNoteTagsContentBuilder implements INoteTagContentBuilder {
  private readonly separator: string;

  /** @param separator - The string to use as a separator between note tags. */
  constructor(separator: string) {
    this.separator = separator;
  }

  getNoteTagContent = (tags: INoteTag[]): string => tags.map(tag => tag.value).join(this.separator);
}

export default SeriesSeparatorNoteTagsContentBuilder;
